import { makeStyles } from "@material-ui/core/styles";
import { ReactNode } from "react";
import { rv } from "../tokens";

export type PillTone = "verified" | "pending" | "review" | "info";

const TONES: Record<PillTone, { fg: string; bg: string; border: string }> = {
  verified: { fg: rv.verifiedFg, bg: rv.verifiedBg, border: rv.verifiedBorder },
  pending: { fg: rv.pendingFg, bg: rv.pendingBg, border: rv.pendingBorder },
  review: { fg: rv.reviewFg, bg: rv.reviewBg, border: rv.reviewBorder },
  info: { fg: rv.infoTitle, bg: rv.infoBg, border: rv.infoBorder },
};

const useStyles = makeStyles({
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "3px 10px",
    borderRadius: 999,
    fontSize: 11.5,
    fontWeight: 600,
    lineHeight: 1.4,
    border: "1px solid",
    whiteSpace: "nowrap",
  },
});

interface Props {
  tone: PillTone;
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export default function StatusPill({ tone, children, icon, className }: Props) {
  const classes = useStyles();
  const palette = TONES[tone];
  return (
    <span
      className={`${classes.pill} ${className || ""}`}
      style={{ color: palette.fg, background: palette.bg, borderColor: palette.border }}
    >
      {icon}
      {children}
    </span>
  );
}
